export function mmToImperial(value, precision = 16) {
  let feetInchFraction = getEmptyImperialNumber(precision);
  if (value < 0) {
    feetInchFraction.sign = '-';
  }
  const positiveValue = Math.abs(value);
  let inches = positiveValue / 25.4;
  feetInchFraction.feet = parseInt(inches / 12);
  feetInchFraction.inch = parseInt(inches) - feetInchFraction.feet * 12;
  feetInchFraction.fraction = getFraction(inches - feetInchFraction.feet * 12 - feetInchFraction.inch, precision);

  if (feetInchFraction.fraction.numerator === 1 && feetInchFraction.fraction.denominator === 1) {
    feetInchFraction.fraction.numerator = 0;
    feetInchFraction.fraction.denominator = precision;
    feetInchFraction.inch += 1;

    if (feetInchFraction.inch == 12) {
      feetInchFraction.inch = 0;
      feetInchFraction.feet += 1;
    }
  }

  return feetInchFraction;
}

export function ftToMm(value) {
  return parseInt(value) * 304.8;
}

export function inToMm(value) {
  return parseFloat(value) * 25.4;
}

export function mm2ToM2(value) {
  return parseInt(value) / 1000000;
}

export function mm2ToFt2(value) {
  const squareFeetInOneSquareMm = 0.00001076391041671;
  return parseInt(value) * squareFeetInOneSquareMm;
}

export function cm2ToMm2(value) {
  return value * 100;
}

export function getFraction(decimalPart, precision = 16) {
  let denominator = precision;
  let numerator = Math.round(decimalPart * denominator);

  if (numerator == 0) {
    return { numerator: 0, denominator: precision };
  }

  while (numerator > 1 && numerator % 2 == 0) {
    denominator /= 2;
    numerator /= 2;
  }

  return { numerator: numerator, denominator: denominator };
}

export function mmToCm(value) {
  return parseInt(value) / 10;
}

export function cmToMm(value) {
  return value * 10;
}

export function mmToM(value) {
  return parseInt(value) / 1000;
}

export function getEmptyImperialNumber(precision = 16) {
  return {
    feet: 0,
    inch: 0,
    fraction: {
      numerator: 0,
      denominator: precision,
    },
    sign: '',
  };
}

function getEmptyMetricNumber() {
  return {
    m: 0,
    cm: 0,
    mm: 0,
    sign: '',
  };
}

function feetToInch(value) {
  return parseInt(value) * 12;
}

export function mmToImperialPattern(value, pattern, precision = 16) {
  var imperial = mmToImperial(value, precision);
  var imperialOutput = getEmptyImperialNumber(precision);
  switch (pattern) {
    case 'inch':
      var inch = feetToInch(imperial.feet) + imperial.inch;
      var fractionInch = Math.round(imperial.fraction.numerator / imperial.fraction.denominator);
      imperialOutput.inch = inch + fractionInch;
      break;
    case 'inch_fraction':
      var inch = feetToInch(imperial.feet) + imperial.inch;
      imperialOutput.inch = inch;
      imperialOutput.fraction = imperial.fraction;
      break;
    case 'feet_inch':
      var fractionInch = Math.round(imperial.fraction.numerator / imperial.fraction.denominator);
      imperialOutput.feet = imperial.feet;
      imperialOutput.inch = imperial.inch + fractionInch;
      if (imperialOutput.inch === 12) {
        imperialOutput.feet += 1;
        imperialOutput.inch = 0;
      }
      break;
    case 'feet_inch_fraction':
    default:
      imperialOutput = imperial;
  }
  imperialOutput.sign = imperial.sign;
  return imperialOutput;
}

export function mmToMetricPattern(valueMm, pattern) {
  var metricOutput = getEmptyMetricNumber();
  if (valueMm < 0) {
    metricOutput.sign = '-';
  }
  const positiveValue = Math.abs(valueMm);
  switch (pattern) {
    case 'm':
      metricOutput.m = mmToM(positiveValue);
      break;
    case 'cm':
      metricOutput.cm = mmToCm(positiveValue);
      break;
    default:
    case 'mm':
      metricOutput.mm = positiveValue;
      break;
  }
  return metricOutput;
}
